import { buildRegistry } from '../core/registry.js';
import { accountProfileFunctionalityFeatures } from './account-profile-functionality.js';
import { additionalAgentSettingsFeatures } from './additional-agent-settings.js';
import { applicationSettingsFeatures } from './application-settings.js';
import { chatFunctionalityFeatures } from './chat-functionality.js';
import { complianceFeatures } from './compliance.js';
import { cubeSecurityContextFeatures } from './cube-security-context.js';
import { dataAgentFeatures } from './data-agent.js';
import { formWorkflowsFeatures } from './form-workflows.js';
import { hcpProfileFunctionalityFeatures } from './hcp-profile-functionality.js';
import { identificationMiddlewareFeatures } from './identification-middleware.js';
import { navbarFeatures } from './navbar.js';
import { repProfileFunctionalityFeatures } from './rep-profile-functionality.js';
import { smartRoutingFeatures } from './smart-routing.js';
import { UserMetadata } from './user-metadata.js';
import { visualizationsFeatures } from './visualizations.js';
import { workspaceFunctionalityFeatures } from './workspace-functionality.js';
export const FEATURES = buildRegistry([
    ...accountProfileFunctionalityFeatures,
    ...chatFunctionalityFeatures,
    ...hcpProfileFunctionalityFeatures,
    ...workspaceFunctionalityFeatures,
    ...navbarFeatures,
    ...applicationSettingsFeatures,
    ...smartRoutingFeatures,
    ...formWorkflowsFeatures,
    ...visualizationsFeatures,
    ...additionalAgentSettingsFeatures,
    ...complianceFeatures,
    ...identificationMiddlewareFeatures,
    ...repProfileFunctionalityFeatures,
    ...cubeSecurityContextFeatures,
    ...dataAgentFeatures,
]);
/**
 * Canonical category list. Union of categories referenced by FEATURES plus
 * categories registered standalone (e.g. UserMetadata, populated at runtime
 * via scoped/user features). DB sync uses this to upsert feature_categories.
 */
export const CATEGORIES = (() => {
    const map = new Map();
    for (const def of FEATURES)
        map.set(def.category.id, def.category.name);
    map.set(UserMetadata.id, UserMetadata.name);
    return [...map.entries()].sort((a, b) => a[0] - b[0]).map(([id, name]) => ({ id, name }));
})();
export * from './additional-agent-settings.js';
export * from './account-profile-functionality.js';
export * from './application-settings.js';
export * from './chat-functionality.js';
export * from './compliance.js';
export * from './cube-security-context.js';
export * from './data-agent.js';
export * from './form-workflows.js';
export * from './hcp-profile-functionality.js';
export * from './identification-middleware.js';
export * from './navbar.js';
export * from './rep-profile-functionality.js';
export * from './smart-routing.js';
export * from './user-metadata.js';
export * from './visualizations.js';
export * from './workspace-functionality.js';
